import KroConstants from "common/constants/kroConstants";

export const WhatsappContainer = () => {
  return (
    <button
      onClick={() => window.open(KroConstants.WHATSAPP_CS_LINK, "_blank")}
      className={`
        fixed 
        bottom-4 
        right-4
        w-[44px] 
        hover:w-[137px] 
        transform-transition 
        duration-300 
        ease-in-out 
        flex 
        items-center 
        justify-center 
        bg-[#4FBA6D] 
        rounded-full 
        group 
        overflow-hidden 
        z-50
        h-[44px]
      `}
    >
      <div className="flex items-center justify-center w-full h-full relative">
        <img
          src={"/assets/icons/whatsapp-white.svg"}
          alt={"whatsapp-logo"}
          height={"20px"}
          width={"20px"}
          className={`
            absolute 
            top-1/2 
            left-1/2 
            transform 
            -translate-x-1/2 
            -translate-y-1/2 
            group-hover:left-3 
            group-hover:-translate-x-0 
            transition-all 
            duration-300
          `}
        />
        <span
          className={`
            absolute 
            left-full 
            opacity-0 
            group-hover:left-[40px] 
            group-hover:opacity-100 
            transition-all 
            duration-300 
            flex 
            items-center 
            whitespace-nowrap
          `}
        >
          <p className={"font-dm-sans font-semibold text-[14px] text-white ml-2"}>
            Need Help?
          </p>
        </span>
      </div>
    </button>
  );
};